module.exports = __webpack_public_path__ + "img/img_tu.002f326b.png";